import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  updateVideoPage,
  getProjectById,
  updateVideoPageActors,
  registerActor,
  getActorByAvatarId,
  generateVideo,
  getActors,
  getVideoPageById,
  removeVideoPageFromProject,
  deleteVideoPage,
  getAllProjects,
  speechToSpeech,
  updateGeneratedVideoStatus,
  removeGeneratedVideo,
  generateVideosMultipleActors,
  getSuggestion,
  generateVideosMultipleScripts,
  getInternalActors,
  uploadSpeechAudio,
  removeSpeechAudio,
  renameGeneratedVideo,
  deleteScript,
  getVideoWithCaptions,
  getCaptionPresets,
  downloadCaptions,
  applyTemplatesToActors,
  applyTemplateToActor,
  uploadVideoToGoogleDrive,
  checkGoogleDriveAccess,
  hasGoogleDriveScope,
  deleteActor,
  generateIVAvatarVideosMultipleActors,
  updateVideoPageAvatarLabActors,
  removeVideoPageAvatarLabActor,
  deleteIVAvatarVideo,
  downloadIVAvatarVideo,
  updateIVAvatarVideoStatus,
  renameIVAvatarVideo,
  generateIVAvatarVideosMultipleScripts,
  deleteAssetActor,
  generateVideoV2,
} from "../../client/api";
import useStyles from "./styles"; // Import the styles
import { useProjectContext } from "../../context/ProjectContext";
import {
  Actor,
  AssetActor,
  CustomPhotoAvatar,
  GeneratedVideo,
  IVAvatarVideo,
  MAX_VIDEOS_PER_FREE_USER,
  Script,
  Variable,
  VideoPage as VideoPageType,
} from "../../context/types"; // Import the VideoPage type
import { THEME_COLORS } from "../../context/constants";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ScriptSvg from "../../icons/ScriptSvg";
import PlayIconSvg from "../../icons/PlayIconSvg";
import {
  Badge,
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Modal,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import InfoIcon from "@mui/icons-material/Info";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ActorsDialog from "../../components/ActorsDialog"; // Import ActorsDialog component
import LightningArrowIcon from "../../icons/LightningArrowIcon";
import { useUserContext } from "../../context/UserContext";
import { useNotification } from "../../context/NotificationContext";
import VideoDialog from "../VideoDialog";
import { DataObject, Download, PlayArrow, Upload } from "@mui/icons-material";
import {
  canUseFeatures,
  delay,
  ensureVariableGroups,
  generateVariableScripts,
  isFreeUser,
  isFullAccessWorkspace,
  migrateLegacyVariables,
} from "../../utils/utils";
import OpenAIModal from "../OpenaiModal";
import VoicePlayer from "../VoicePlayer";
import Message from "../Message";
import ScriptGuidelinesModal from "../GuidelinesModal";
import VariableModal from "../VariablesDialog";
import Papa from "papaparse";
import CreativeRequestModal from "../CreativeRequestDialog";
import TemplateDialog from "../TemplatesDialog";
import { getTemplates } from "../../client/api";
import Cookies from "js-cookie";
import GoogleDriveUploadModal from "../GoogleDriveCallback/GoogleDriveUploadModal";
import GoogleDriveAccessNotification from "../GoogleDriveAccessNotification";
import AvatarLabVoicePlayer from "../AvatarLabVoicePlayer";
import GeneratedVideoItem from "./components/GeneratedVideoItem";
import BulkCreativeUpload from "./components/BulkCreativeUpload";
import MultipleScriptsModal from "./components/MultipleScriptsModal";
import AssetActorCard from "./components/AssetActorCard";
import AssetActorCreationModal from "./components/AssetActorCreationModal";

const VideoPage = () => {
  const classes = useStyles(); // Initialize the styles
  const { projectId, videoPageId } = useParams();
  const {
    avatars,
    talkingPhotos,
    cachedCustomPhotoAvatars,
    fetchAvatars,
    currentProject,
    setCurrentProject,
    projects,
    setProjects,
    currentScript,
    setCurrentScript,
  } = useProjectContext();
  const { user, currentWorkspace } = useUserContext();
  const { addNotification } = useNotification(); // Use the notification hook
  const [videoPage, setVideoPage] = useState<VideoPageType | null>(null); // Use the correct type
  const [anchorEl, setAnchorEl] = useState(null);

  const [headline, setHeadline] = useState<string>("");
  const [body, setBody] = useState<string>("");
  const [cta, setCta] = useState<string>("");
  const [isActorsDialogOpen, setIsActorsDialogOpen] = useState(false); // State for managing dialog
  const [isLoadingAvatars, setIsLoadingAvatars] = useState(false); // Loading state for avatars
  const [actors, setActors] = useState<Actor[]>([]);
  const [generatedVideos, setGeneratedVideos] = useState<GeneratedVideo[]>([]);
  const [ivAvatarVideos, setIvAvatarVideos] = useState<IVAvatarVideo[]>([]);
  const [showGeneratedVideos, setShowGeneratedVideos] = useState(false);
  const [selectedVideoActor, setSelectedVideoActor] = useState(actors[0] || null);
  const [selectedVideoActors, setSelectedVideoActors] = useState<string[]>([]);

  const [avatarLabActors, setAvatarLabActors] = useState<CustomPhotoAvatar[]>([]);
  const [selectedAvatarLabActors, setSelectedAvatarLabActors] = useState<string[]>([]);
  const [assetActors, setAssetActors] = useState<AssetActor[]>([]);
  const [selectedAssetActors, setSelectedAssetActors] = useState<string[]>([]);
  const [isAssetActorModalOpen, setIsAssetActorModalOpen] = useState(false);
  const [actorTab, setActorTab] = useState<"actors" | "avatarLab" | "imageActors">("actors");
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [updatedName, setUpdatedName] = useState(videoPage?.name || "");
  const [isLoading, setIsLoading] = useState(false);
  const [videoBeingRefreshed, setVideoBeingRefreshed] = useState<string | null>(null);
  const [videoBeingDeleted, setVideoBeingDeleted] = useState<string | null>(null);
  const [generatingVideos, setGeneratingVideos] = useState(false);
  const generatingVideosRef = React.useRef(false);
  const [isVideoDialogOpen, setIsVideoDialogOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [captionUrl, setCaptionUrl] = useState("");
  const navigate = useNavigate(); // Initialize navigate
  const [openAIModal, setOpenAIModal] = useState<boolean>(false);
  const [currentPrompt, setCurrentPrompt] = useState<string>("");
  const [reloadPrompt, setReloadPrompt] = useState<string>("");
  const [scriptPart, setScriptPart] = useState<"headline" | "body" | "cta">("headline");
  const [isVariableModalOpen, setIsVariableModalOpen] = useState(false);
  const [selectedVariable, setSelectedVariable] = useState<string | null>(null);
  const [newVariableValue, setNewVariableValue] = useState<string>("");
  const [scriptVariable, setScriptVariable] = useState<Variable>();
  const [scriptType, setScriptType] = useState<"text" | "speech">(
    videoPage?.speechAudioUrl ? "speech" : "text"
  );
  const [audioFile, setAudioFile] = useState<File | null>(null);
  const [isBackgroundSettingsOpen, setIsBackgroundSettingsOpen] = useState(false);
  const [selectedActorForSettings, setSelectedActorForSettings] = useState<Actor | null>(null);
  const [isLoadingSpeechFile, setIsLoadingSpeechFile] = useState(false);
  const [dimension, setDimension] = useState({ width: 1080, height: 1920 });
  const [resolution, setResolution] = useState<"4k" | "1080p" | "720p">("720p");
  const [isGuidelinesModalOpen, setIsGuidelinesModalOpen] = useState(false);
  const [isCreativeRequestModalOpen, setIsCreativeRequestModalOpen] = useState(false);

  const [videoBeingRenamed, setVideoBeingRenamed] = useState<string | null>(null);
  const [newVideoName, setNewVideoName] = useState("");
  const [selectAllActors, setSelectAllActors] = useState(false);
  const [burningCaptions, setBurningCaptions] = useState<string | null>(null);
  const [burningProgress, setBurningProgress] = useState(0);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [isDriveConnected, setIsDriveConnected] = useState(false);
  const [isUploadingToDrive, setIsUploadingToDrive] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState("");
  const [googleDriveModalOpen, setGoogleDriveModalOpen] = useState(false);
  const [selectedVideoForUpload, setSelectedVideoForUpload] = useState<
    GeneratedVideo | IVAvatarVideo | null
  >(null);
  const [showDriveNotification, setShowDriveNotification] = useState(false);
  const [captionStyle, setCaptionStyle] = useState<string>("default");
  const [captionExportType, setCaptionExportType] = useState<"baked_in" | "separate" | "both">("baked_in");
  const [captionPresets, setCaptionPresets] = useState<string[]>([]);
  const [showCaptionThemeCustom, setShowCaptionThemeCustom] = useState(false);
  const [captionTheme, setCaptionTheme] = useState<{
    fontFamily?: string;
    fontSize?: number;
    color?: string;
    backgroundColor?: string;
    position?: string;
  } | null>(null);
  const [isMultipleScriptsModalOpen, setIsMultipleScriptsModalOpen] = useState(false);

  //bulk creative upload

  interface ScriptEntry {
    id: string;
    headline: string;
    body: string;
    cta: string;
    fullScript: string;
    status: string;
  }

  const [scripts, setScripts] = useState<ScriptEntry[]>([]);

  useEffect(() => {
    const checkNotifications = async () => {
      if (user?._id) {
        const { hasAccess, hasSeenNotification } = await checkGoogleDriveAccess(user._id);
        if (hasAccess && !hasSeenNotification) {
          setShowDriveNotification(true);
        }
      }
    };
    checkNotifications();
  }, [user]);

  useEffect(() => {
    const loadCaptionPresets = async () => {
      try {
        const { presets } = await getCaptionPresets();
        setCaptionPresets(Array.isArray(presets) ? presets : []);
      } catch {
        setCaptionPresets(["default", "classic", "kinetic", "minimal"]);
      }
    };
    loadCaptionPresets();
  }, []);

  useEffect(() => {
    setVideoPage(null);
    const fetchProjectAndSetPage = async () => {
      setActors([]);
      if (projectId) {
        try {
          const project = await getProjectById(projectId);
          setCurrentProject(project);
          const page = project.videoPages.find((vp: VideoPageType) => vp._id === videoPageId);
          if (page) {
            // Migrate to new variable system if needed
            const migratedPage = {
              ...page,
              script: page.script?.map((script: Script) => migrateLegacyVariables(script)),
            };

            setVideoPage(migratedPage);
            setScriptType(migratedPage?.speechAudioUrl ? "speech" : "text");
            setCurrentScript(migratedPage.script?.[0]);
            setGeneratedVideos(migratedPage?.generatedVideos || []);
            setActors(migratedPage.actors || []);
            setSelectedVideoActors(
              (migratedPage.actors || []).map((actor: Actor) => actor.avatar_id)
            );
            setAvatarLabActors(migratedPage.ivAvatars || []);
            setSelectedAvatarLabActors(
              (migratedPage.ivAvatars || []).map((avatar: CustomPhotoAvatar) => avatar._id)
            );
            setAssetActors(migratedPage.assetActors || []);
            setSelectedAssetActors(
              (migratedPage.assetActors || []).map((a: AssetActor) => a._id)
            );

            setHeadline(migratedPage.script?.[0]?.headline || "");
            setBody(migratedPage.script?.[0]?.body || "");
            setCta(migratedPage.script?.[0]?.cta || "");
          }
        } catch (error) {
          console.error("Failed to fetch project:", error);
        }
      }
    };

    fetchProjectAndSetPage();
  }, [projectId, videoPageId, setCurrentProject]);

  useEffect(() => {
    if (actors.length > 0) {
      setSelectedVideoActor(actors[0]);
    }
  }, [actors]);

  useEffect(() => {
    if (!canUseFeatures(currentWorkspace)) {
      setScriptType("text");
    }
  }, [currentWorkspace]);

  // Auto-switch to text mode when any selected actor has a template
  useEffect(() => {
    const hasSelectedActorsWithTemplates = selectedVideoActors.some((actorId) => {
      const actor = videoPage?.actors?.find((a) => a.avatar_id === actorId);
      return actor?.heygenTemplate;
    });

    if (hasSelectedActorsWithTemplates && scriptType === "speech") {
      setScriptType("text");
      addNotification(
        "Switched to Text Script mode. Speech to Speech is not available when an avatar with a template is selected.",
        "info"
      );
    }
  }, [selectedVideoActors, videoPage?.actors, scriptType, addNotification]);

  const handleOpenGoogleDriveModal = (video: GeneratedVideo | IVAvatarVideo) => {
    // Check if user has Google Drive scope
    if (!hasGoogleDriveScope()) {
      addNotification("Additional Google Drive permissions required", "info");
    }
    setSelectedVideoForUpload(video);
    setGoogleDriveModalOpen(true);
  };

  const handleDriveUploadSuccess = (videoId: string, driveUrl: string) => {
    // Update local state
    setGeneratedVideos((prevVideos) =>
      prevVideos.map((video) =>
        video._id === videoId ? { ...video, googleDriveUrl: driveUrl } : video
      )
    );

    // Update videoPage state
    setVideoPage((prevPage) => {
      if (!prevPage) return prevPage;
      return {
        ...prevPage,
        generatedVideos: prevPage.generatedVideos.map((video) =>
          video._id === videoId ? { ...video, googleDriveUrl: driveUrl } : video
        ),
      };
    });
  };

  const handleCloseGoogleDriveModal = () => {
    setGoogleDriveModalOpen(false);
    setSelectedVideoForUpload(null);
  };

  const handleRenameIVAvatarVideo = async (videoId: string, newName: string) => {
    if (!newName.trim()) return;
    try {
      setVideoBeingRenamed(videoId);
      await renameIVAvatarVideo(videoId, newName);

      // Update local state
      setIvAvatarVideos((prev) =>
        prev.map((video) => (video._id === videoId ? { ...video, name: newName } : video))
      );

      // Also update the videoPage state
      setVideoPage((prevPage) => {
        if (!prevPage) return prevPage;
        return {
          ...prevPage,
          ivAvatarVideos: prevPage.ivAvatarVideos.map((video) =>
            video._id === videoId ? { ...video, name: newName } : video
          ),
        };
      });

      addNotification("Video renamed successfully!", "success");
      setNewVideoName("");
    } catch (error) {
      console.error("Failed to rename video:", error);
      addNotification("Failed to rename video", "error");
    } finally {
      setVideoBeingRenamed(null);
    }
  };

  const handleRefreshIVAvatarVideo = async (videoId: string) => {
    try {
      await updateIVAvatarVideoStatus(videoId);

      // Refresh the video page to get updated status
      const updatedVideoPage = await getVideoPageById(videoPageId || "");
      setVideoPage(updatedVideoPage);
    } catch (error) {
      console.error("Error updating video status:", error);
    }
  };

  const handleDownloadIVAvatarVideo = async (video: IVAvatarVideo) => {
    try {
      const { downloadUrl } = await downloadIVAvatarVideo(video._id);

      // Create download link
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `${video.name || "avatar_lab_video"}.mp4`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      addNotification("Failed to download video", "error");
    }
  };

  const handleDeleteIVAvatarVideo = async (videoId: string) => {
    try {
      await deleteIVAvatarVideo(videoId);

      // Update local state
      setIvAvatarVideos((prev) => prev.filter((video) => video._id !== videoId));

      addNotification("Video deleted", "success");
    } catch (error) {
      addNotification("Error deleting video", "error");
    }
  };

  const handleUploadToGoogleDrive = async (video: GeneratedVideo) => {
    try {
      setIsUploadingToDrive(true);
      const videoUrl = video?.withCaptions ? video.video_url_caption : video.video_url;
      if (!videoUrl) return;

      const fileName = video.name || `video-${video.heygenId}.mp4`;

      // Get Google access token from wherever you store it
      const accessToken =
        localStorage.getItem("google_access_token") || Cookies.get("google_access_token");

      if (!accessToken) {
        throw new Error("Google access token not found. Please sign in again.");
      }

      const result = await uploadVideoToGoogleDrive(accessToken, videoUrl, fileName);

      addNotification("Video uploaded to Google Drive successfully!", "success");
    } catch (error: any) {
      console.error("Error uploading to Google Drive:", error);
      addNotification(error.message || "Failed to upload to Google Drive", "error");
    } finally {
      setIsUploadingToDrive(false);
    }
  };

  // Function to handle file upload
  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files || !event.target.files[0]) {
      addNotification("No audio file selected.", "warning");
      return;
    }

    const file = event.target.files[0];

    if (!currentWorkspace || !projectId || !videoPageId || !currentScript) {
      addNotification("Required information is missing.", "error");
      return;
    }

    try {
      setIsLoadingSpeechFile(true); // Set loading state
      const workspaceId = currentWorkspace._id;
      const scriptName = currentScript.name;

      // Call the uploadSpeechAudio API
      const speechAudioUrl = await uploadSpeechAudio(
        workspaceId,
        projectId,
        videoPageId,
        scriptName,
        file
      );

      // Update the videoPage state with the new speechAudioUrl
      setVideoPage((prevVideoPage) => {
        if (!prevVideoPage) return prevVideoPage;
        return {
          ...prevVideoPage,
          speechAudioUrl, // Update the speechAudioUrl field
        };
      });

      addNotification("Audio uploaded successfully!", "success");
    } catch (error) {
      console.error("Error uploading audio:", error);
      addNotification("Failed to upload audio. Please try again.", "error");
    } finally {
      setIsLoadingSpeechFile(false); // Reset loading state
    }
  };

  const handleApplyTemplate = async (
    templateId: string,
    actorIds: string[],
    variables: any,
    selectedActorsFromDialog?: Actor[],
    perActorVariables?: { [actorId: string]: any }
  ) => {
    if (!templateId || !actorIds.length) return;

    try {
      setIsLoadingAvatars(true);

      let finalActorIds = actorIds;
      let newActorAvatarIds: string[] = [];
      let actorIdMapping: { [oldId: string]: string } = {}; // Map old IDs to registered IDs

      // If we have actors from dialog, we need to ensure they're registered first
      if (selectedActorsFromDialog && selectedActorsFromDialog.length > 0) {
        // Step 1: Ensure all selected actors are registered and get their IDs
        const registeredActorIds = await ensureActorsRegistered(selectedActorsFromDialog);

        if (!registeredActorIds || registeredActorIds.length === 0) {
          throw new Error("Failed to register actors");
        }

        // Create mapping from original actor IDs to registered IDs
        selectedActorsFromDialog.forEach((actor, index) => {
          if (registeredActorIds[index]) {
            actorIdMapping[actor._id] = registeredActorIds[index];
          }
        });

        // Get the current actor IDs already on the video page
        const existingActorIds = actors.map((actor) => actor._id);

        // Merge existing and new actor IDs, removing duplicates
        const allActorIds = Array.from(new Set([...existingActorIds, ...registeredActorIds]));

        // Step 2: Update the video page with ALL actor IDs (existing + new)
        const updatedVideoPage = await updateVideoPageActors(
          videoPageId || "",
          allActorIds,
          user?.email || ""
        );

        // Step 3: Update local state with new actors
        setVideoPage(updatedVideoPage);
        setActors(updatedVideoPage.actors || []);

        // Track the avatar_ids of newly added actors for selection
        newActorAvatarIds = selectedActorsFromDialog.map((a) => a.avatar_id);

        // Now use the registered actor IDs for template application
        finalActorIds = registeredActorIds;
      }

      // Apply template to each actor with their specific variables
      const allUpdatedActors: any[] = [];

      // If we have selectedActorsFromDialog, iterate directly over them to preserve the mapping
      if (selectedActorsFromDialog && selectedActorsFromDialog.length > 0 && perActorVariables) {
        for (let i = 0; i < selectedActorsFromDialog.length; i++) {
          const actor = selectedActorsFromDialog[i];
          const actorId = finalActorIds[i]; // Registered ID at same index
          const actorVariables = perActorVariables[actor.avatar_id] || variables;

          const results = await applyTemplatesToActors([actorId], templateId, actorVariables);

          if (results.actors && results.actors.length > 0) {
            allUpdatedActors.push(...results.actors);
          }
        }
      } else {
        // Fallback for when no dialog actors - apply base variables to all
        const results = await applyTemplatesToActors(finalActorIds, templateId, variables);

        if (results.actors && results.actors.length > 0) {
          allUpdatedActors.push(...results.actors);
        }
      }

      // Update the local state with all updated actors
      setActors((prevActors) =>
        prevActors.map((actor) => {
          const updatedActor = allUpdatedActors.find((a: any) => a._id === actor._id);
          return updatedActor || actor;
        })
      );

      // Update selectedVideoActors to select ONLY the actors that had template applied
      // This ensures that when user generates videos, only these template actors are used
      if (newActorAvatarIds.length > 0) {
        setSelectedVideoActors(newActorAvatarIds);
      }

      addNotification(`Template applied to ${finalActorIds.length} actor(s)`, "success");
      setIsTemplateModalOpen(false);
    } catch (error) {
      console.error("Failed to apply template:", error);
      addNotification("Failed to apply template to some actors", "error");
    } finally {
      setIsLoadingAvatars(false);
    }
  };

  const handleTemplateAdded = (newTemplateActor: Actor) => {
    // Update the actors list with the new template actor
    setActors((prevActors) => [...prevActors, newTemplateActor]);

    // Also update the selected video actors if needed
    setSelectedVideoActors((prev) => [...prev, newTemplateActor.avatar_id]);

    addNotification("Template added successfully!", "success");
  };

  // Function to handle speech-to-speech conversion
  const handleSpeechToSpeech = async () => {
    if (!audioFile || !videoPageId) {
      addNotification("Please upload an audio file first.", "warning");
      return;
    }

    try {
      setIsLoading(true);
      //call api method
    } catch (error) {
      console.error("Error during speech-to-speech conversion:", error);
      addNotification("Failed to convert speech to speech.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteScript = async () => {
    if (!videoPage || !currentScript || !user?.email) return;

    try {
      const { videoPage: updatedVideoPage, newCurrentScript } = await deleteScript(
        videoPage._id,
        currentScript._id,
        user.email
      );

      setVideoPage(updatedVideoPage);
      setCurrentScript(newCurrentScript);
      addNotification("Script deleted successfully", "success");
    } catch (error) {
      addNotification("Error deleting script", "error");
      console.error("Error deleting script:", error);
    }
  };

  // Add this function to handle renaming
  const handleRenameVideo = async (videoId: string) => {
    if (!newVideoName.trim()) return;

    try {
      setVideoBeingRenamed(videoId);
      await renameGeneratedVideo(videoId, newVideoName);

      // Update both generatedVideos and videoPage states
      setGeneratedVideos((prevVideos) =>
        prevVideos.map((video) =>
          video._id === videoId ? { ...video, name: newVideoName } : video
        )
      );

      setVideoPage((prevPage) => {
        if (!prevPage) return prevPage;
        return {
          ...prevPage,
          generatedVideos: prevPage.generatedVideos.map((video) =>
            video._id === videoId ? { ...video, name: newVideoName } : video
          ),
        };
      });

      addNotification("Video renamed successfully!", "success");
      setNewVideoName("");
    } catch (error) {
      console.error("Failed to rename video:", error);
      addNotification("Failed to rename video", "error");
    } finally {
      setVideoBeingRenamed(null);
    }
  };

  // Function to ensure all actors are registered and return their IDs
  const ensureActorsRegistered = async (selectedActors: Actor[]) => {
    if (!currentWorkspace || !videoPageId) return;

    const actorIds: string[] = [];

    try {
      // Step 1: Fetch internal actors
      const internalActors = await getInternalActors();

      for (const actor of selectedActors) {
        try {
          // Step 2: Check if the actor already exists in the database
          const existingActor = internalActors.find(
            (internalActor: any) =>
              internalActor.avatar_id === actor.avatar_id &&
              internalActor.workspace === currentWorkspace._id &&
              internalActor.videoPage === videoPageId
          );

          if (existingActor) {
            // If the actor exists, push its ID to the array
            actorIds.push(existingActor._id);
          } else {
            // Step 3: Register the actor if not already in the database
            const registeredActor = await registerActor({
              avatar_id: actor.avatar_id,
              avatar_name: actor.avatar_name,
              preview_video_url: actor.preview_video_url,
              preview_image_url: actor.preview_image_url,
              gender: actor.gender,
              workspaceId: currentWorkspace._id,
              videoPageId,
              isTalkingPhoto: !!actor?.isTalkingPhoto,
            });

            // Push the new actor's ID to the array
            actorIds.push(registeredActor._id);
          }
        } catch (error: any) {
          console.error("Error registering actor:", error?.message);

          // Handle unexpected errors
          if (error.response && error.response.status === 400) {
            // If actor already exists but not in internalActors, fetch its ID
            const existingActor = await getActorByAvatarId(
              actor.avatar_id,
              currentWorkspace._id,
              videoPageId
            );
            actorIds.push(existingActor._id);
          } else {
            throw error; // Re-throw if it's an unexpected error
          }
        }
      }
    } catch (error: any) {
      console.error("Error fetching internal actors:", error?.message);
      throw error;
    }

    return actorIds; // Return all registered actor IDs
  };

  const handleDoneSelectingAvatars = async (selectedActors: Actor[]) => {
    if (!videoPage) return;

    setIsLoadingAvatars(true); // Start loading

    try {
      // Step 1: Ensure all actors are registered and get their IDs
      const registeredActorIds = await ensureActorsRegistered(selectedActors);

      // Step 2: Update the video page with the registered actor IDs
      const updatedVideoPage = await updateVideoPageActors(
        videoPageId || "",
        registeredActorIds,
        user?.email || ""
      );

      // Step 3: Fetch updated project data to reflect the new actors
      const updatedProject = await getProjectById(projectId || currentProject?._id || "");
      setCurrentProject(updatedProject); // Update the current project state with the new actors

      // Set the new actor list on the video page
      /*setVideoPage((prevPage) => {
        if (prevPage) {
          return { ...prevPage, actors: selectedActors }; // Assuming you're keeping selectedActors for display
        }
        return prevPage;
      });*/
      setVideoPage(updatedVideoPage);

      setSelectedVideoActors([]);
    } catch (error) {
      console.error("Failed to update actors:", error);
    } finally {
      setIsLoadingAvatars(false); // End loading
    }
  };

  const handleDoneSelectingAvatarLabActors = async (
    selectedAvatarLabActors: CustomPhotoAvatar[]
  ) => {
    if (!videoPage || !currentWorkspace || !user?.email) return;

    setIsLoadingAvatars(true);

    try {
      // Get the IDs of the selected Avatar Lab actors
      const avatarLabActorIds = selectedAvatarLabActors.map((actor) => actor._id);

      // Update the video page with the Avatar Lab actor IDs
      const updatedVideoPage = await updateVideoPageAvatarLabActors(
        videoPageId || "",
        avatarLabActorIds,
        user.email,
        currentWorkspace._id
      );

      // Update local state
      setVideoPage(updatedVideoPage);
      setAvatarLabActors(selectedAvatarLabActors);
      setSelectedAvatarLabActors(avatarLabActorIds);
    } catch (error) {
      console.error("Failed to update avatar lab actors:", error);
      addNotification("Failed to update avatar lab actors", "error");
    } finally {
      setIsLoadingAvatars(false);
    }
  };

  // Add handleDeselectAvatarLabActor function
  const handleDeselectAvatarLabActor = async (avatarLabActorId: string) => {
    if (!currentWorkspace || !videoPageId) return;

    try {
      // Remove from backend - use the correct field (ivAvatars)
      await removeVideoPageAvatarLabActor(videoPageId, avatarLabActorId);

      // Update local state
      setSelectedAvatarLabActors((prev) => prev.filter((id) => id !== avatarLabActorId));
      setAvatarLabActors((prev) => prev.filter((actor) => actor._id !== avatarLabActorId));

      // Also update the videoPage state - use ivAvatars, not ivAvatarVideos
      setVideoPage((prevPage) => {
        if (!prevPage) return prevPage;
        return {
          ...prevPage,
          ivAvatars: prevPage.ivAvatars?.filter((avatar) => avatar._id !== avatarLabActorId) || [],
        };
      });

      addNotification("Avatar Lab actor removed successfully", "success");
    } catch (error: any) {
      console.error("Error removing avatar lab actor:", error);
      addNotification("Failed to remove avatar lab actor", "error");
    }
  };

  // Switch from Avatar Lab (enhanced) mode to Photo Avatar mode
  const handleSwitchToPhotoAvatarMode = async (avatarLabActor: CustomPhotoAvatar) => {
    if (!currentWorkspace || !videoPageId || !user?.email) return;

    // Find the corresponding photo avatar by matching generation_id in preview_image_url
    const photoAvatar = talkingPhotos?.find(
      (photo) =>
        !!avatarLabActor.generation_id &&
        photo.preview_image_url?.includes(avatarLabActor.generation_id)
    );

    if (!photoAvatar) {
      addNotification("Could not find the photo avatar version", "error");
      return;
    }

    setIsLoadingAvatars(true);

    try {
      // Step 1: Remove the Avatar Lab actor from the video page
      await removeVideoPageAvatarLabActor(videoPageId, avatarLabActor._id);

      // Step 2: Add the photo avatar to the actors list
      const actorToAdd: Actor = {
        ...photoAvatar,
        _id: "", // Will be assigned by backend
        workspace: currentWorkspace._id,
        videoPage: videoPageId,
        voice_settings: {
          type: "text",
          voice_id: avatarLabActor.heygenVoiceId || "",
          input_text: "",
          speed: 1.0,
          pitch: 0,
        },
        heygenVoiceId: avatarLabActor.heygenVoiceId,
        heygenVoiceAudioUrl: avatarLabActor.heygenVoiceAudioUrl,
        elevenLabsVoiceId: avatarLabActor.elevenLabsVoiceId,
        voiceName: avatarLabActor.voiceName,
        talking_photo_id: photoAvatar.avatar_id,
        talking_photo_name: photoAvatar.avatar_name,
        isTalkingPhoto: true,
      };

      // Ensure the actor is registered and get the registered actor IDs
      const registeredActorIds = await ensureActorsRegistered([...actors, actorToAdd]);

      // Update the video page with the new actors
      const updatedVideoPage = await updateVideoPageActors(
        videoPageId,
        registeredActorIds,
        user.email
      );

      // Update local state - remove from avatar lab actors
      setSelectedAvatarLabActors((prev) => prev.filter((id) => id !== avatarLabActor._id));
      setAvatarLabActors((prev) => prev.filter((actor) => actor._id !== avatarLabActor._id));

      // Fetch updated project data to reflect the new actors
      const updatedProject = await getProjectById(projectId || currentProject?._id || "");
      setCurrentProject(updatedProject);
      setVideoPage(updatedVideoPage);
      setActors(updatedVideoPage.actors || []);
      setSelectedVideoActors((updatedVideoPage.actors || []).map((a: Actor) => a.avatar_id));

      addNotification("Switched to Photo Avatar mode successfully", "success");
    } catch (error: any) {
      console.error("Error switching to photo avatar mode:", error);
      addNotification("Failed to switch to photo avatar mode", "error");
    } finally {
      setIsLoadingAvatars(false);
    }
  };

  // Switch from Photo Avatar mode to Avatar Lab (enhanced) mode
  const handleSwitchToEnhancedMode = async (actor: Actor) => {
    if (!currentWorkspace || !videoPageId || !user?.email) return;

    // Find the corresponding Avatar Lab actor by matching generation_id in actor's preview_image_url
    const avatarLabActor =
      avatarLabActors.find(
        (avatar) =>
          !!avatar.generation_id &&
          actor.preview_image_url?.includes(avatar.generation_id)
      ) ||
      cachedCustomPhotoAvatars?.find(
        (avatar: CustomPhotoAvatar) =>
          !!avatar.generation_id &&
          actor.preview_image_url?.includes(avatar.generation_id)
      );

    if (!avatarLabActor) {
      addNotification("Could not find the Avatar Lab version", "error");
      return;
    }

    setIsLoadingAvatars(true);

    try {
      // Step 1: Remove the photo avatar actor from the video page
      await handleDeselectActor(actor.avatar_id);

      // Step 2: Add the Avatar Lab actor to the video page
      const avatarLabActorIds = [...avatarLabActors.map((a) => a._id), avatarLabActor._id];
      const updatedVideoPage = await updateVideoPageAvatarLabActors(
        videoPageId,
        avatarLabActorIds,
        user.email,
        currentWorkspace._id
      );

      // Update local state
      setVideoPage(updatedVideoPage);
      setAvatarLabActors(updatedVideoPage.ivAvatars || []);
      setSelectedAvatarLabActors(
        (updatedVideoPage.ivAvatars || []).map((a: CustomPhotoAvatar) => a._id)
      );

      addNotification("Switched to Enhanced mode successfully", "success");
    } catch (error: any) {
      console.error("Error switching to enhanced mode:", error);
      addNotification("Failed to switch to enhanced mode", "error");
    } finally {
      setIsLoadingAvatars(false);
    }
  };

  // Separate selection handlers
  const handleSelectAvatarLabActor = (actorId: string) => {
    setSelectedAvatarLabActors((prev) => {
      if (prev.includes(actorId)) {
        return prev.filter((id) => id !== actorId);
      } else {
        return [...prev, actorId];
      }
    });
  };

  const handleSelectAssetActor = (actorId: string, isCheckboxClick?: boolean) => {
    setSelectedAssetActors((prev) => {
      if (isCheckboxClick) {
        return prev.includes(actorId)
          ? prev.filter((id) => id !== actorId)
          : [...prev, actorId];
      }
      return prev.includes(actorId) ? prev : [...prev, actorId];
    });
  };

  const handleDeselectAssetActor = async (actorId: string) => {
    try {
      await deleteAssetActor(actorId);
      setAssetActors((prev) => prev.filter((a) => a._id !== actorId));
      setSelectedAssetActors((prev) => prev.filter((id) => id !== actorId));
      addNotification("Image actor removed", "success");
    } catch (err) {
      addNotification("Failed to remove image actor", "error");
    }
  };

  const handleAssetActorCreated = (newActor: AssetActor) => {
    setAssetActors((prev) => [...prev, newActor]);
    setSelectedAssetActors((prev) => [...prev, newActor._id]);
  };

  const handleUpdateAssetActor = (updated: AssetActor) => {
    setAssetActors((prev) =>
      prev.map((a) => (a._id === updated._id ? updated : a))
    );
  };

  // Updated frontend handler
  const handleDownloadVideo = async (
    video: GeneratedVideo | IVAvatarVideo,
    videoUrlToDownload?: string
  ) => {
    try {
      let videoDownloadUrl = videoUrlToDownload || "";
      let fileName = video.name || "video";

      // If no URL provided, try to get the best available URL
      if (!videoDownloadUrl) {
        // First, try to get video with captions if heygenId exists
        if (video.heygenId) {
          try {
            const { videoUrl } = await getVideoWithCaptions(video.heygenId);
            if (videoUrl) {
              videoDownloadUrl = videoUrl;
              fileName = `${fileName}_with_captions`;
            }
          } catch (captionError) {
            console.log("Captions not available, falling back to regular video");
          }
        }

        // If still no URL, fall back to the regular video_url
        if (!videoDownloadUrl) {
          // Check for video_url on GeneratedVideo or video_url on IVAvatarVideo
          const regularUrl =
            (video as GeneratedVideo).video_url || (video as IVAvatarVideo).video_url;

          if (regularUrl) {
            videoDownloadUrl = regularUrl;
          }
        }
      }

      // If we still don't have a URL, show an error
      if (!videoDownloadUrl) {
        addNotification("No video URL available for download", "error");
        return;
      }

      // Create direct download link
      const link = document.createElement("a");
      link.href = videoDownloadUrl;
      link.download = `${fileName}.mp4`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      addNotification("Failed to download video", "error");
    }
  };

  const handleDownloadCaptions = async (
    video: GeneratedVideo | IVAvatarVideo,
    format: 'ass' | 'srt' | 'txt' | 'svg'
  ) => {
    try {
      // Download captions in the specified format
      const blob = await downloadCaptions(video._id, format);

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${video.name || "subtitle"}.${format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      addNotification(`Captions downloaded as ${format.toUpperCase()}`, "success");
    } catch (error) {
      console.error("Failed to download captions:", error);
      addNotification("Failed to download captions", "error");
    }
  };

  const handleDeleteVideoPage = async () => {
    if (!videoPageId || !projectId || !currentWorkspace) return;

    try {
      // Call the API to remove the video page from the project
      await removeVideoPageFromProject(projectId, videoPageId);
      // Call the API to delete the video page
      await deleteVideoPage(videoPageId);
      // Update projects
      const projectsResponse = await getAllProjects(1, 10, "", currentWorkspace._id);
      setProjects(projectsResponse.projects);
      // Redirect to the home page
      navigate("/");
      // Show success notification
      addNotification("Video page deleted successfully!", "success");
    } catch (error: any) {
      console.error("Failed to delete video page:", error);
      // Show error notification
      addNotification(`Failed to delete video page - ${error?.response?.data?.message}`, "error");
    }
  };

  const handleEditDialogOpen = () => {
    setUpdatedName(videoPage?.name || ""); // Reset to current name
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = () => {
    setIsEditDialogOpen(false);
  };

  const handleUpdateVideoPageName = async () => {
    if (!videoPageId) return;
    try {
      // Update the video page on the server
      await updateVideoPage(videoPageId, { name: updatedName }, user?.email || "");

      // Update the local video page state
      setVideoPage((prevPage) => (prevPage ? { ...prevPage, name: updatedName } : prevPage));

      // Find the index of the current project
      const projectIndex = projects.findIndex((project) => project._id === currentProject?._id);

      if (projectIndex !== -1) {
        // Update the video page name in the current project's video pages
        const updatedProjects = [...projects];
        const videoPageIndex = updatedProjects[projectIndex].videoPages.findIndex(
          (videoPage) => videoPage._id === videoPageId
        );

        if (videoPageIndex !== -1) {
          updatedProjects[projectIndex].videoPages[videoPageIndex] = {
            ...updatedProjects[projectIndex].videoPages[videoPageIndex],
            name: updatedName,
          };

          // Update the projects state
          setProjects(updatedProjects);
          // Update the current project in context if necessary
          setCurrentProject(updatedProjects[projectIndex]);
        }
      }

      addNotification("Video page name updated successfully!", "success");
      handleEditDialogClose();
    } catch (error: any) {
      console.error("Failed to update video page name:", error);
      addNotification(`Failed to update video page name - ${error?.message}`, "error");
    }
  };

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleScriptSelect = (script: Script) => {
    setCurrentScript(script);
    setHeadline(script?.headline || "");
    setBody(script?.body || "");
    setCta(script?.cta || "");
    handleMenuClose();
  };

  const handleScriptSave = async () => {
    if (!currentScript || !user || !videoPage) return;

    // Ensure we're using the new format before saving
    const scriptToSave = migrateLegacyVariables(currentScript);

    // Find the script to update in videoPage.script array
    const updatedScripts = videoPage.script.map((script) =>
      script._id === currentScript._id ? scriptToSave : script
    );

    // Create a new videoPage object with the updated scripts
    const updatedVideoPage = {
      script: updatedScripts,
    };

    try {
      setIsLoading(true);
      // Send the updated videoPage object to the updateVideoPage function
      const savedVideoPage = await updateVideoPage(videoPageId || "", updatedVideoPage, user.email);
      setVideoPage(savedVideoPage);
      //addNotification("Script updated successfully!", "success");
    } catch (error) {
      console.error("Failed to update script:", error);
      //addNotification("Failed to update script", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddNewScript = async (isCloning = false) => {
    if (!videoPage || !user) return;

    try {
      // Create a new script with default values (or empty ones)
      const newScript = {
        headline: isCloning ? currentScript?.headline : "",
        body: isCloning ? currentScript?.body : "",
        cta: isCloning ? currentScript?.cta : "",
        variables: isCloning ? currentScript?.variables : undefined,
      };

      // Update the videoPage by adding the new script to the existing ones
      const updatedScripts = [...(videoPage.script || []), newScript];

      const updatedData = { script: updatedScripts };

      // Update the video page with the new script array
      const savedVideoPage = await updateVideoPage(
        videoPageId || "",
        updatedData,
        user.email || ""
      );
      if (savedVideoPage._id) {
        setVideoPage(savedVideoPage);
        setCurrentScript(savedVideoPage.script?.[savedVideoPage.script.length - 1]);
        const message = isCloning
          ? "Script cloned successfully"
          : "New script added to the video page";
        addNotification(message, "success");
      }
      // Fetch and update the current project to reflect the changes
      const updatedProject = await getProjectById(projectId || currentProject?._id || "");
      setCurrentProject(updatedProject);
    } catch (error: any) {
      addNotification("Error adding new script", "error");
    }
  };

  const setScriptHeadline = (value: string) => {
    if (!currentScript) return;
    setCurrentScript({ ...currentScript, headline: value });
    setHeadline(value);
  };

  const setScriptBody = (value: string) => {
    if (!currentScript) return;
    setCurrentScript({ ...currentScript, body: value });
    setBody(value);
  };

  const setScriptCta = (value: string) => {
    if (!currentScript) return;
    setCurrentScript({ ...currentScript, cta: value });
    setCta(value);
  };

  useEffect(() => {
    setActors(videoPage?.actors || []);
    setGeneratedVideos(videoPage?.generatedVideos || []);
    setAvatarLabActors(videoPage?.ivAvatars || []);
    setIvAvatarVideos(videoPage?.ivAvatarVideos || []);
    setAssetActors(videoPage?.assetActors || []);
  }, [videoPage]);

  async function updateVideoStatusAndProject(videoId: string, isIVAvatar: boolean = false) {
    if (!videoPageId) return;
    try {
      setVideoBeingRefreshed(videoId);

      if (isIVAvatar) {
        // Update IV Avatar video status
        await updateIVAvatarVideoStatus(videoId);
      } else {
        // Update regular video status
        await updateGeneratedVideoStatus(videoId);
      }

      // Refresh the entire video page to get all updated videos
      const updatedVideoPage: VideoPageType = await getVideoPageById(videoPageId);

      // Update all state with the fetched video page data
      setVideoPage(updatedVideoPage);
      if (updatedVideoPage?.generatedVideos) {
        setGeneratedVideos(updatedVideoPage.generatedVideos);
      }
      if (updatedVideoPage?.ivAvatarVideos) {
        setIvAvatarVideos(updatedVideoPage.ivAvatarVideos);
      }

      setShowGeneratedVideos(true);
    } catch (error) {
      console.error("Error updating video status and project:", error);
    } finally {
      setVideoBeingRefreshed(null);
    }
  }

  async function deleteGeneratedVideo(videoId: string) {
    if (!videoPage) return;
    try {
      setVideoBeingDeleted(videoId);
      const updatedVideoPage = await removeGeneratedVideo(videoPage?._id, videoId);
      setVideoPage(updatedVideoPage);
      addNotification("Video deleted", "success");
    } catch (error) {
      addNotification("Error deleting video", "error");
    } finally {
      setVideoBeingDeleted(null);
    }
  }

  const handleGenerateVideos = async () => {
    // Prevent double execution using ref (synchronous check)
    if (generatingVideosRef.current) return;
    generatingVideosRef.current = true;

    if (
      !videoPage ||
      !videoPageId ||
      (!videoPage.actors && !videoPage.ivAvatars) ||
      //!videoPage.actors.length ||
      !currentProject ||
      !currentScript ||
      !currentWorkspace
    ) {
      console.error("Missing required data for video generation.");
      generatingVideosRef.current = false;
      return;
    }

    // Determine actor type from active tab
    const hasRegularActors = actorTab === "actors" && selectedVideoActors.length > 0;
    const hasAvatarLabActors = actorTab === "avatarLab" && selectedAvatarLabActors.length > 0;
    const hasAssetActors = actorTab === "imageActors" && selectedAssetActors.length > 0;

    if (!hasRegularActors && !hasAvatarLabActors && !hasAssetActors) {
      addNotification("Please select at least one actor in the active tab to generate videos.", "warning");
      generatingVideosRef.current = false;
      return;
    }

    // Check workspace limits
    if (
      currentWorkspace.category !== "fullaccess" &&
      !currentWorkspace.plan &&
      currentWorkspace.generatedVideos > MAX_VIDEOS_PER_FREE_USER
    ) {
      addNotification("Upgrade to generate more videos", "warning");
      generatingVideosRef.current = false;
      return;
    }

    // Check actor selection limits for free users
    if (!canUseFeatures(currentWorkspace) && selectedVideoActors.length !== 1) {
      addNotification(
        "Please select only one actor or upgrade to generate multiple videos at once.",
        "warning"
      );
      generatingVideosRef.current = false;
      return;
    }

    // Check for variables
    const { variableGroups } = ensureVariableGroups(currentScript);
    const hasVariables = variableGroups.length > 0 && variableGroups[0].variables.length > 0;

    if (hasVariables && selectedVideoActors.length !== 1 && selectedAvatarLabActors.length !== 1 && !hasAssetActors) {
      addNotification(
        "Please select exactly one actor to generate videos with variables.",
        "warning"
      );
      generatingVideosRef.current = false;
      return;
    }

    // Check if variables have values
    const hasEmptyVariables =
      hasVariables && variableGroups[0].variables.some((v) => v.values.length === 0);

    if (hasEmptyVariables) {
      addNotification("Please fill variable values to be able to generate videos.", "warning");
      generatingVideosRef.current = false;
      return;
    }

    // Check template compatibility for speech-to-speech
    if (
      scriptType === "speech" &&
      selectedVideoActors.some((actorId) => {
        const actor = videoPage?.actors?.find((a) => a.avatar_id === actorId);
        return actor?.heygenTemplate;
      })
    ) {
      addNotification("Currently templates do not support speech to speech scripts.", "error");
      generatingVideosRef.current = false;
      return;
    }

    try {
      setGeneratingVideos(true);

      // Arrays to collect all video IDs for status polling
      const allVideoIds: { id: string; isIVAvatar: boolean }[] = [];

      // Generate regular actor videos
      if (hasRegularActors) {
        if (hasVariables && scriptType === "text") {
          const variableScripts = generateVariableScripts(currentScript);
          const videoIds = await generateVideosMultipleScripts(
            currentWorkspace._id,
            videoPage._id,
            selectedVideoActors[0],
            "",
            variableScripts,
            dimension,
            user?.email || "",
            {
              captionStyle,
              captionExportType,
              ...(captionTheme && Object.keys(captionTheme).length > 0 && { captionTheme }),
              resolution,
            }
          );

          // Add to tracking array
          videoIds.forEach((id: string) => allVideoIds.push({ id, isIVAvatar: false }));
        } else {
          const voiceIds: Record<string, string> = {};
          for (const actor of actors || []) {
            const actorId = actor.avatar_id;
            if (selectedVideoActors.includes(actorId)) {
              const existingActor = await getActorByAvatarId(
                actor.avatar_id,
                currentWorkspace._id,
                videoPageId
              );
              voiceIds[actorId] = existingActor?.heygenVoiceId || "";
            }
          }

          const videoIds = await generateVideosMultipleActors(
            currentWorkspace._id,
            videoPage._id,
            selectedVideoActors,
            voiceIds,
            currentScript,
            currentScript._id,
            dimension,
            user?.email || "",
            videoPageId,
            scriptType === "speech",
            {
              captionStyle,
              captionExportType,
              ...(captionTheme && Object.keys(captionTheme).length > 0 && { captionTheme }),
              resolution,
            }
          );

          // Add to tracking array
          videoIds.forEach((id) => allVideoIds.push({ id, isIVAvatar: false }));
        }
      }

      // Generate Avatar Lab actor videos
      if (hasAvatarLabActors) {
        const selectedAvatarLabActorData = avatarLabActors.filter((actor) =>
          selectedAvatarLabActors.includes(actor._id)
        );

        // Validate Avatar Lab actors — V3 uses avatar_look_id, V2 uses image_key_list
        const invalidAvatars = selectedAvatarLabActorData.filter(
          (actor) =>
            !actor.avatar_look_id &&
            !actor.selected_image_key &&
            actor.image_key_list.length === 0
        );

        if (invalidAvatars.length > 0) {
          addNotification(
            `Some Avatar Lab avatars don't have generated images yet: ${invalidAvatars
              .map((a) => a.name)
              .join(", ")}`,
            "error"
          );
          return;
        }

        if (hasVariables && scriptType === "text") {
          const variableScripts = generateVariableScripts(currentScript);
          const firstAvatarLabActor = selectedAvatarLabActorData[0];

          const videoIds = await generateIVAvatarVideosMultipleScripts(
            currentWorkspace._id,
            videoPage._id,
            firstAvatarLabActor._id,
            variableScripts,
            dimension,
            user?.email || "",
            resolution
          );

          // Add to tracking array
          videoIds.forEach((id: string) => allVideoIds.push({ id, isIVAvatar: true }));
        } else {
          const videoIds = await generateIVAvatarVideosMultipleActors(
            currentWorkspace._id,
            videoPage._id,
            selectedAvatarLabActorData,
            currentScript,
            dimension,
            user?.email || "",
            scriptType === "speech",
            scriptType === "speech" ? videoPage?.speechAudioUrl : undefined,
            resolution
          );

          // Add to tracking array
          videoIds.forEach((id) => allVideoIds.push({ id, isIVAvatar: true }));
        }
      }

      // Generate Asset Actor (V2) videos
      if (hasAssetActors) {
        const selectedAssetActorData = assetActors.filter((a) =>
          selectedAssetActors.includes(a._id)
        );

        // If the script has variables, generate one video per variable replacement
        // (mirrors the regular-actor / avatar-lab variable flow). Image Actors are
        // text-only so this branch only applies when scriptType === "text".
        const scriptsToGenerate: Script[] =
          hasVariables && scriptType === "text"
            ? generateVariableScripts(currentScript)
            : [currentScript];

        for (const assetActor of selectedAssetActorData) {
          if (!assetActor.voice_id) {
            addNotification(
              `Image actor "${assetActor.name}" has no voice selected. Please select a voice first.`,
              "warning"
            );
            generatingVideosRef.current = false;
            setGeneratingVideos(false);
            return;
          }
          for (const scriptVariant of scriptsToGenerate) {
            try {
              const result = await generateVideoV2({
                videoPageId: videoPage._id,
                workspaceId: currentWorkspace._id,
                assetActorId: assetActor._id,
                userEmail: user?.email || "",
                scriptId: scriptVariant._id,
                script: {
                  headline: scriptVariant.headline || "",
                  body: scriptVariant.body || "",
                  cta: scriptVariant.cta || "",
                },
                resolution,
              });
              // Status polling endpoint expects the heygenId, not the mongo doc _id
              if (result?.heygenId) {
                allVideoIds.push({ id: result.heygenId, isIVAvatar: false });
              }
            } catch (err: any) {
              console.error("Error generating V2 video:", err);
              addNotification(
                `Failed to generate video for "${assetActor.name}": ${err?.response?.data?.message || err?.message || "Unknown error"}`,
                "error"
              );
            }
          }
        }
      }

      // Start polling for all video statuses
      await Promise.all(
        allVideoIds.map(async ({ id, isIVAvatar }) => {
          await updateVideoStatusAndProject(id, isIVAvatar);
        })
      );

      // Refresh the entire video page to ensure we have the latest data
      const updatedVideoPage = await getVideoPageById(videoPageId || "");
      setVideoPage(updatedVideoPage);
      setShowGeneratedVideos(true);
      addNotification(
        `Started generating ${allVideoIds.length} video${allVideoIds.length !== 1 ? "s" : ""}`,
        "success"
      );
    } catch (error: any) {
      console.error("Failed to generate video:", error);
      const message = error?.response?.data?.message || error?.message;
      const displayMessage = message ? ` ${message}` : "";
      setShowGeneratedVideos(false);
      addNotification("Failed to generate videos, " + displayMessage, "error");
    } finally {
      setGeneratingVideos(false);
      generatingVideosRef.current = false;
    }
  };

  const handleGenerateWithMultipleScripts = async (
    selectedScripts: Script[],
    selectedActorId: string,
    actorKind: "regular" | "avatarLab" | "assetActor"
  ) => {
    if (
      !videoPage ||
      !videoPageId ||
      !currentProject ||
      !currentWorkspace ||
      selectedScripts.length === 0
    ) {
      addNotification("Missing required data for video generation.", "error");
      return;
    }

    try {
      setGeneratingVideos(true);
      const allVideoIds: { id: string; isIVAvatar: boolean }[] = [];

      if (actorKind === "assetActor") {
        const assetActor = assetActors.find((a) => a._id === selectedActorId);
        if (!assetActor) {
          addNotification("Selected image actor not found.", "error");
          return;
        }
        if (!assetActor.voice_id) {
          addNotification(
            `Image actor "${assetActor.name}" has no voice selected. Please select a voice first.`,
            "warning"
          );
          return;
        }
        for (const scriptVariant of selectedScripts) {
          try {
            const result = await generateVideoV2({
              videoPageId: videoPage._id,
              workspaceId: currentWorkspace._id,
              assetActorId: assetActor._id,
              userEmail: user?.email || "",
              scriptId: scriptVariant._id,
              script: {
                headline: scriptVariant.headline || "",
                body: scriptVariant.body || "",
                cta: scriptVariant.cta || "",
              },
              resolution,
            });
            // Status polling endpoint expects the heygenId, not the mongo doc _id
            if (result?.heygenId) {
              allVideoIds.push({ id: result.heygenId, isIVAvatar: false });
            }
          } catch (err: any) {
            console.error("Error generating V2 video:", err);
            addNotification(
              `Failed to generate video for "${assetActor.name}": ${err?.response?.data?.message || err?.message || "Unknown error"}`,
              "error"
            );
          }
        }
      } else if (actorKind === "avatarLab") {
        // Generate videos for Avatar Lab actor
        const selectedAvatarLabActor = avatarLabActors.find(
          (actor) => actor._id === selectedActorId
        );

        if (!selectedAvatarLabActor) {
          addNotification("Selected Avatar Lab actor not found.", "error");
          return;
        }

        // Validate Avatar Lab actor — V3 uses avatar_look_id, V2 uses image_key_list
        if (
          !selectedAvatarLabActor.avatar_look_id &&
          !selectedAvatarLabActor.selected_image_key &&
          selectedAvatarLabActor.image_key_list.length === 0
        ) {
          addNotification(
            `Avatar Lab avatar ${selectedAvatarLabActor.name} doesn't have generated images yet.`,
            "error"
          );
          return;
        }

        const videoIds = await generateIVAvatarVideosMultipleScripts(
          currentWorkspace._id,
          videoPage._id,
          selectedAvatarLabActor._id,
          selectedScripts,
          dimension,
          user?.email || "",
          resolution
        );

        videoIds.forEach((id: string) => allVideoIds.push({ id, isIVAvatar: true }));
      } else {
        // Generate videos for regular actor
        const videoIds = await generateVideosMultipleScripts(
          currentWorkspace._id,
          videoPage._id,
          selectedActorId,
          "",
          selectedScripts,
          dimension,
          user?.email || "",
          { resolution }
        );

        videoIds.forEach((id: string) => allVideoIds.push({ id, isIVAvatar: false }));
      }

      // Start polling for all video statuses
      await Promise.all(
        allVideoIds.map(async ({ id, isIVAvatar }) => {
          await updateVideoStatusAndProject(id, isIVAvatar);
        })
      );

      // Refresh the entire video page to ensure we have the latest data
      const updatedVideoPage = await getVideoPageById(videoPageId || "");
      setVideoPage(updatedVideoPage);
      setShowGeneratedVideos(true);
      setIsMultipleScriptsModalOpen(false);
      addNotification(
        `Started generating ${allVideoIds.length} video${allVideoIds.length !== 1 ? "s" : ""} with multiple scripts`,
        "success"
      );
    } catch (error: any) {
      console.error("Failed to generate videos with multiple scripts:", error);
      const message = error?.response?.data?.message || error?.message;
      const displayMessage = message ? ` ${message}` : "";
      addNotification("Failed to generate videos, " + displayMessage, "error");
    } finally {
      setGeneratingVideos(false);
    }
  };

  const toggleView = () => {
    setShowGeneratedVideos((prevState) => !prevState);
  };

  const handleCloseVideoDialog = () => {
    setIsVideoDialogOpen(false);
    setVideoUrl("");
    setCaptionUrl("");
  };
  const handleOpenVideoDialog = (videoUrl?: string, captionUrl = "") => {
    if (!videoUrl) return;
    setVideoUrl(videoUrl);
    setCaptionUrl(captionUrl);
    setIsVideoDialogOpen(true);
  };

  const getScriptUsed = (scriptId?: string) => {
    if (!scriptId || !videoPage || !currentScript) return "";

    // Check if scriptId includes '-variant-'
    const isVariant = scriptId.includes("-variant-");

    if (isVariant) {
      const [baseScriptId, variantId] = scriptId.split("-variant-");
      const variantIndex = parseInt(variantId, 10);

      // Get the script with variables
      const script = videoPage.script.find((s) => s._id === baseScriptId);
      if (!script) return "";

      // Use the new variableGroups format
      const { variableGroups } = ensureVariableGroups(script);
      if (variableGroups.length === 0) return script.name || "";

      const variables = variableGroups[0].variables;

      // Build the variant string with all variable values
      let variantString = `${script.name} - ` || "";

      variables.forEach((variable, i) => {
        const valueObj = variable.values[variantIndex];
        if (valueObj) {
          if (i > 0) variantString += " | ";
          variantString += `${variable.name}: ${valueObj.value}`;
        }
      });

      return variantString;
    }

    // If no variant, just return the script name
    const videoScript = videoPage.script.find((s) => s._id === scriptId);
    return videoScript?.name || "";
  };

  //OPENAI
  const handleOpenAIModal = (scriptPartClicked: "headline" | "body" | "cta") => {
    setScriptPart(scriptPartClicked);
    setOpenAIModal(true);
  };

  const handleCloseAIModal = () => {
    setOpenAIModal(false);
  };

  const handleUseOpenAIResponse = (response: string) => {
    if (scriptPart === "headline") {
      setScriptHeadline(response);
    } else if (scriptPart === "body") {
      setScriptBody(response);
    } else if (scriptPart === "cta") {
      setScriptCta(response);
    }
  };

  // todo next
  const handleReloadPrompt = async () => {
    if (currentPrompt.trim() === "") return;
    const maxTokens = 50;
    const response = await getSuggestion(currentPrompt, maxTokens);
    if (response.suggestion) {
      handleUseOpenAIResponse(response.suggesetion);
    }
  };

  const handleHeadlineChange = (value: string) => {
    if (!currentScript) return;
    setScriptHeadline(value);
    setCurrentScript({ ...currentScript, headline: value });
  };

  const handleOpenVariableModal = () => {
    const variable = currentScript?.variables?.[0]?.name || null;
    setSelectedVariable(variable);
    setIsVariableModalOpen(true);
  };

  const handleSelectActors = (actorId: string, isCheckboxClick = false) => {
    setSelectedVideoActors((prevSelectedActors) => {
      // If clicking the checkbox, toggle selection normally
      if (isCheckboxClick) {
        return prevSelectedActors.includes(actorId)
          ? prevSelectedActors.filter((id) => id !== actorId)
          : [...prevSelectedActors, actorId];
      }
      // If clicking anywhere else, always select (unless already selected)
      return prevSelectedActors.includes(actorId)
        ? prevSelectedActors
        : [...prevSelectedActors, actorId];
    });
  };

  const handleSelectAllActors = () => {
    if (selectAllActors) {
      setSelectedVideoActors([]);
    } else {
      setSelectedVideoActors(actors.map((actor) => actor.avatar_id));
    }
    setSelectAllActors(!selectAllActors);
  };

  const handleRemoveSpeechAudio = async () => {
    if (!videoPageId) return;
    try {
      await removeSpeechAudio(videoPageId);
      addNotification("Speech audio removed", "success");
      setVideoPage((prevVideoPage) => {
        if (!prevVideoPage) return prevVideoPage;
        return {
          ...prevVideoPage,
          speechAudioUrl: undefined, // Update the speechAudioUrl field
        };
      });
    } catch (error: any) {
      addNotification("Error removing speech audio", "error");
    }
  };

  const handleDeselectActor = async (actorId: string) => {
    if (!currentWorkspace || !videoPageId) return;
    try {
      // Remove actor from database
      await deleteActor(actorId, currentWorkspace._id, videoPageId);

      // Update local state
      setSelectedVideoActors((prev) => prev.filter((id) => id !== actorId));
      setActors((prev) => prev.filter((actor) => actor.avatar_id !== actorId));

      // Also update the videoPage state
      setVideoPage((prevPage) => {
        if (!prevPage) return prevPage;
        return {
          ...prevPage,
          actors: prevPage.actors?.filter((actor) => actor.avatar_id !== actorId),
        };
      });

      addNotification("Actor removed successfully", "success");
    } catch (error: any) {
      console.error("Error removing actor:", error);
      addNotification("Failed to remove actor", "error");
    }
  };

  useEffect(() => {
    handleScriptSave();
  }, [currentScript]);

  const applyBulkScripts = async (incomingScripts: any[]) => {
    if (!videoPage || incomingScripts.length === 0) return;
    if (!user) return;

    const updatedScripts = [...(videoPage.script || []), ...incomingScripts];

    const updatedData = { script: updatedScripts };

    const savedVideoPage = await updateVideoPage(videoPageId ?? "", updatedData, user.email ?? "");

    if (savedVideoPage._id) {
      setVideoPage(savedVideoPage);
      addNotification("Bulk scripts added successfully", "success");
      setScripts([]);
    }
  };

  // O filho manda os scripts prontos → o pai já aplica
  const handleBulkConfirm = (scriptsFromChild: any[]) => {
    applyBulkScripts(scriptsFromChild);
  };

  return (
    <>
      {!!videoPage ? (
        <div className={classes.videoPage}>
          {showDriveNotification && (
            <GoogleDriveAccessNotification
              userId={user?._id}
              onClose={() => setShowDriveNotification(false)}
            />
          )}
          {/* Top Section: Video Page Title */}
          <div className={classes.videoPageHeader}>
            <div className={classes.titleMenu}>
              <h1>{videoPage?.name}</h1>
              <div className={classes.videoPageActions}>
                <IconButton onClick={handleEditDialogOpen} sx={{ color: "#FFBF00" }}>
                  <EditIcon />
                </IconButton>
                <IconButton onClick={handleDeleteVideoPage} sx={{ color: "#FFBF00" }}>
                  <DeleteIcon />
                </IconButton>
              </div>
            </div>
            <span className={classes.lastUpdatedBy}>
              {videoPage.lastUpdatedBy.length > 0
                ? videoPage.lastUpdatedBy[videoPage.lastUpdatedBy.length - 1]
                : ""}
            </span>
          </div>
          {videoPage?.creativeRequest && (
            <>
              <Box sx={{ display: "flex", justifyContent: "left", my: 1 }}>
                <Chip
                  label={`from creative request by ${videoPage.creativeRequest.requester?.name}`}
                  color="primary"
                  size="small"
                  onClick={() => setIsCreativeRequestModalOpen(true)}
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      opacity: 0.9,
                    },
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                  }}
                />
              </Box>

              <CreativeRequestModal
                open={isCreativeRequestModalOpen}
                onClose={() => setIsCreativeRequestModalOpen(false)}
                creativeRequest={videoPage.creativeRequest}
                requesterName={videoPage.creativeRequest.requester?.name}
              />
            </>
          )}
          <div className={classes.columnsContainer}>
            <div className={classes.videoPageContent}>
              {/* Left Column: Script */}
              <div className={classes.scriptSection}>
                <div
                  className={classes.scriptTitle}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className={classes.scriptToggle}>
                    <ScriptSvg />
                    <Button
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleMenuOpen}
                      endIcon={<ArrowDropDownIcon sx={{ color: "#000" }} />}
                    >
                      <span className={classes.title}>{currentScript?.name || "Script"}</span>
                    </Button>

                    <Tooltip title="Add new script">
                      <IconButton
                        onClick={() => handleAddNewScript(false)}
                        sx={{ color: "#FFBF00" }}
                      >
                        <AddCircleOutlineIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Clone current script">
                      <IconButton
                        onClick={() => handleAddNewScript(true)}
                        sx={{ color: "#FFBF00" }}
                      >
                        <ContentCopyIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Save current script">
                      <IconButton onClick={handleScriptSave} disabled={isLoading}>
                        {isLoading ? (
                          <CircularProgress size={24} />
                        ) : (
                          <SaveIcon sx={{ color: "#FFBF00" }} />
                        )}
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete current script">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteScript();
                        }}
                        sx={{ color: "#FFBF00" }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      {videoPage.script.map((script) => (
                        <MenuItem key={script._id} onClick={() => handleScriptSelect(script)}>
                          {script.name}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                  <Tooltip title="Add or manage bulk creative scripts">
                    <Badge badgeContent={"new"} color="primary">
                      <BulkCreativeUpload
                        scripts={scripts}
                        setScripts={setScripts}
                        onBulkConfirm={handleBulkConfirm}
                      />
                    </Badge>
                  </Tooltip>
                  <div className={classes.scriptMenu}>
                    {/* Toggle between Script and Speech to Speech */}
                    {(() => {
                      const hasSelectedActorsWithTemplates = selectedVideoActors.some((actorId) => {
                        const actor = videoPage?.actors?.find((a) => a.avatar_id === actorId);
                        return actor?.heygenTemplate;
                      });
                      const isImageActorsTab = actorTab === "imageActors";
                      return (
                        <Tooltip
                          title={
                            isImageActorsTab
                              ? "Image Actors only support Text Script for now"
                              : hasSelectedActorsWithTemplates
                              ? "Unselect the avatar with template to use Speech to Speech"
                              : scriptType === "text"
                              ? "Switch to Speech to Speech"
                              : "Switch to Text Script"
                          }
                        >
                            <Button
                              onClick={() => {
                                if (isImageActorsTab) {
                                  addNotification(
                                    "Image Actors only support Text Script for now",
                                    "warning"
                                  );
                                  return;
                                }
                                if (hasSelectedActorsWithTemplates) {
                                  addNotification(
                                    "Unselect the avatar with template to use Speech to Speech",
                                    "warning"
                                  );
                                  return;
                                }
                                if (!canUseFeatures(currentWorkspace)) {
                                  setScriptType("text");
                                  addNotification("Upgrade to use Speech to Speech", "warning");
                                  return;
                                }
                                setScriptType(scriptType === "text" ? "speech" : "text");
                              }}
                              disabled={isImageActorsTab || (hasSelectedActorsWithTemplates && scriptType === "text")}
                              sx={{
                                marginLeft: "10px",
                                color: isImageActorsTab || (hasSelectedActorsWithTemplates && scriptType === "text") ? "#888" : "#FFBF00",
                                backgroundColor: "black",
                                "&:disabled": {
                                  color: "#888",
                                  backgroundColor: "black",
                                },
                              }}
                            >
                              {scriptType === "text" ? "Speech to Speech" : "Text Script"}
                            </Button>
                        </Tooltip>
                      );
                    })()}
                  </div>
                </div>
                <div className={classes.divider} />
                {/* Icon Button for Script Guidelines */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",

                    marginBottom: "10px",
                  }}
                >
                  {scriptType === "text" ? (
                    <Tooltip title="Add or manage script variables">
                      <IconButton onClick={handleOpenVariableModal} sx={{ color: "#FFBF00" }}>
                        <DataObject />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                  <Tooltip
                    title={
                      scriptType === "speech" ? "How to Use Speech-to-Speech" : "Script Guidelines"
                    }
                  >
                    <IconButton
                      onClick={() => setIsGuidelinesModalOpen(true)} // Open the modal
                      sx={{ color: "#FFBF00" }} // Customize the icon color
                    >
                      <InfoIcon /> {/* Use an appropriate icon */}
                    </IconButton>
                  </Tooltip>
                </div>
                {scriptType === "text" ? (
                  <>
                    <div className={classes.scriptPart}>
                      <div className={classes.scriptSectionTitle}>
                        <label className={classes.label}>Headline / Hook</label>
                      </div>
                      <div className={classes.scriptActions}>
                        <textarea
                          className={classes.textarea}
                          value={currentScript?.headline}
                          onChange={(e) => handleHeadlineChange(e.target.value)}
                          //onBlur={handleScriptSave}
                        />
                        <div className="scriptActionItems">
                          <Tooltip title="Ask AI for a suggestion">
                            <IconButton
                              onClick={() => handleOpenAIModal("headline")}
                              sx={{ color: "#FFBF00" }}
                            >
                              <AddCircleOutlineIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Coming soon: refresh AI suggestions and automatically add to the field">
                            <IconButton
                              onClick={() => ""}
                              sx={{
                                color: THEME_COLORS.darkGray,
                                cursor: "help",
                              }}
                            >
                              <RefreshIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    <div className={classes.scriptPart}>
                      <div className={classes.scriptSectionTitle}>
                        <label className={classes.label}>body</label>
                      </div>
                      <div className={classes.scriptActions}>
                        <textarea
                          className={classes.textarea}
                          value={currentScript?.body}
                          onChange={(e) => setScriptBody(e.target.value)}
                          onBlur={handleScriptSave}
                        />
                        <div className="scriptActionItems">
                          <Tooltip title="Ask AI for a suggestion">
                            <IconButton
                              onClick={() => handleOpenAIModal("body")}
                              sx={{ color: "#FFBF00" }}
                            >
                              <AddCircleOutlineIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Coming soon: refresh AI suggestions and automatically add to the field">
                            <IconButton
                              onClick={() => ""}
                              sx={{
                                color: THEME_COLORS.darkGray,
                                cursor: "help",
                              }}
                            >
                              <RefreshIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    <div className={classes.scriptPart}>
                      <div className={classes.scriptSectionTitle}>
                        <label className={classes.label}>cta</label>
                      </div>
                      <div className={classes.scriptActions}>
                        <textarea
                          className={classes.textarea}
                          value={currentScript?.cta}
                          onChange={(e) => setScriptCta(e.target.value)}
                          onBlur={handleScriptSave}
                        />
                        <div className="scriptActionItems">
                          <Tooltip title="Ask AI for a suggestion">
                            <IconButton
                              onClick={() => handleOpenAIModal("cta")}
                              sx={{ color: "#FFBF00" }}
                            >
                              <AddCircleOutlineIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Coming soon: refresh AI suggestions and automatically add to the field">
                            <IconButton
                              onClick={() => ""}
                              sx={{
                                color: THEME_COLORS.darkGray,
                                cursor: "help",
                              }}
                            >
                              <RefreshIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  // Render the Speech to Speech UI
                  <div className={classes.scriptPart}>
                    <div className={classes.scriptSectionTitle}>
                      <label className={classes.label}>SPEECH TO SPEECH</label>
                    </div>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2, // Adds spacing between elements
                      }}
                    >
                      {/* File Upload Button */}
                      <Button
                        variant="contained"
                        component="label"
                        startIcon={<Upload />} // Add an upload icon
                        disabled={isLoading}
                        sx={{
                          backgroundColor: "#FFBF00", // Custom color
                          color: "#000", // Text color
                          "&:hover": {
                            backgroundColor: "#e6ac00", // Darker shade on hover
                          },
                        }}
                      >
                        Upload Audio
                        <input
                          type="file"
                          accept="audio/*"
                          onChange={handleFileUpload}
                          hidden // Hide the default file input
                        />
                      </Button>

                      {/* Display the selected file name */}
                      {!!videoPage?.speechAudioUrl && (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography variant="body1">
                            Uploaded Audio:{" "}
                            <strong>{videoPage.speechAudioUrl.split("/").pop()}</strong>
                          </Typography>
                          <Tooltip title="Remove speech audio">
                            <IconButton onClick={handleRemoveSpeechAudio} sx={{ color: "#FFBF00" }}>
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}

                      {/* Audio Player */}
                      {videoPage?.speechAudioUrl && (
                        <Box sx={{ mt: 2 }}>
                          <audio
                            controls
                            src={videoPage.speechAudioUrl}
                            style={{ width: "100%" }}
                          />
                        </Box>
                      )}

                      {/* Loading Indicator */}
                      {isLoadingSpeechFile && (
                        <Typography variant="body2" sx={{ mt: 2 }}>
                          Uploading...
                        </Typography>
                      )}
                    </Box>
                  </div>
                )}
              </div>

              {/* Right Column: Generated Videos */}
              <div className={classes.generatedVideosSection}>
                <div className={classes.scriptTitle}>
                  <PlayIconSvg />
                  <span className={classes.title}>
                    Generated Videos (
                    {videoPage?.generatedVideos.length + videoPage?.ivAvatarVideos.length})
                  </span>
                  <IconButton
                    onClick={() => setIsActorsDialogOpen(true)}
                    sx={{ color: "#FFBF00" }}
                  ></IconButton>
                  <span
                    className={classes.addActorsText}
                    onClick={() => setIsActorsDialogOpen(true)}
                    style={{ cursor: "pointer" }}
                  >
                    + Add Actors
                  </span>
                </div>
                <div className={classes.divider} />

                {(videoPage?.generatedVideos.length > 0 ||
                  videoPage?.ivAvatarVideos.length > 0) && (
                  <button onClick={toggleView} className={classes.generatedVideosNavigationButton}>
                    {showGeneratedVideos ? (
                      <>
                        <ArrowBackIcon sx={{ marginRight: "5px", width: "18px" }} /> Back to Actors
                        List
                      </>
                    ) : (
                      <>
                        Go to Generated Videos{" "}
                        <ArrowForwardIcon sx={{ marginLeft: "5px", width: "18px" }} />
                      </>
                    )}
                  </button>
                )}
                {/* Conditions for showing content inside Generated Videos Section */}
                {/* If there are no generated videos or we're not in the 'generated videos' view, show actors list */}
                {!showGeneratedVideos ||
                (videoPage?.generatedVideos.length === 0 &&
                  videoPage?.ivAvatarVideos.length === 0) ? (
                  <div className={classes.avatarListSection}>
                    {/* Action buttons row */}
                    <Box sx={{ display: "flex", gap: 1.5, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
                      <Tooltip title="Select HeyGen actors or Avatar Lab avatars">
                        <Button
                          variant="contained"
                          onClick={() => setIsActorsDialogOpen(true)}
                          sx={{
                            minWidth: "160px",
                            backgroundColor: "#FFBF00",
                            color: "#000",
                            fontFamily: "Lexend, sans-serif",
                            fontSize: "13px",
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: THEME_COLORS.darkYellow,
                            },
                          }}
                        >
                          + Add Actors
                        </Button>
                      </Tooltip>
                      <Tooltip title="Upload an image to animate as a talking actor in your video">
                        <Badge badgeContent={"new"} color="secondary">
                          <Button
                            variant="outlined"
                            onClick={() => setIsAssetActorModalOpen(true)}
                            sx={{
                              minWidth: "160px",
                              borderColor: "#00897B",
                              color: "#333",
                              fontFamily: "Lexend, sans-serif",
                              fontSize: "13px",
                              textTransform: "none",
                              "&:hover": {
                                borderColor: "#00695C",
                                backgroundColor: "#E0F2F1",
                              },
                            }}
                          >
                            + Add Image Actor
                          </Button>
                        </Badge>
                      </Tooltip>
                      <Tooltip title="Add a template and select actors">
                        <Badge badgeContent={"new"} color="secondary">
                          <Button
                            variant="outlined"
                            onClick={() => setIsTemplateModalOpen(true)}
                            sx={{
                              minWidth: "160px",
                              borderColor: THEME_COLORS.yellow,
                              color: "#333",
                              fontFamily: "Lexend, sans-serif",
                              fontSize: "13px",
                              textTransform: "none",
                              "&:hover": {
                                borderColor: THEME_COLORS.darkYellow,
                                backgroundColor: THEME_COLORS.lightYellow3,
                              },
                            }}
                          >
                            Add Template
                          </Button>
                        </Badge>
                      </Tooltip>
                    </Box>

                    {actors?.length === 0 && avatarLabActors?.length === 0 && assetActors?.length === 0 ? (
                      // No actors yet
                      <p>You will find your ad videos here.</p>
                    ) : (
                      // Actors available
                      <>
                        {/* Actor type tabs */}
                        <Tabs
                          value={actorTab}
                          onChange={(_, v) => {
                            setActorTab(v);
                            // Clear selections from other tabs — only one actor type at a time
                            if (v !== "actors") setSelectedVideoActors([]);
                            if (v !== "avatarLab") setSelectedAvatarLabActors([]);
                            if (v !== "imageActors") setSelectedAssetActors([]);
                            // Image actors are only compatible with text-to-speech for now
                            if (v === "imageActors") setScriptType("text");
                          }}
                          sx={{
                            mb: 2,
                            minHeight: "36px",
                            "& .MuiTab-root": {
                              minHeight: "36px",
                              textTransform: "none",
                              fontFamily: "Lexend, sans-serif",
                              fontSize: "13px",
                              fontWeight: 500,
                              py: 0.5,
                              color: "#666",
                            },
                            "& .MuiTabs-indicator": {
                              backgroundColor: THEME_COLORS.yellow,
                            },
                            "& .Mui-selected": {
                              color: `${THEME_COLORS.darkYellow} !important`,
                            },
                          }}
                        >
                          <Tab
                            value="actors"
                            label={`Actors (${actors.length})`}
                          />
                          <Tab
                            value="avatarLab"
                            label={`Avatar Lab (${avatarLabActors.length})`}
                          />
                          <Tab
                            value="imageActors"
                            label={`Image Actors (${assetActors.length})`}
                          />
                        </Tabs>

                        {scriptType === "text" && !!currentScript?.variables?.length && (
                          <Typography
                            variant="body2"
                            style={{
                              marginTop: "4px",
                              fontSize: "12px",
                              color: THEME_COLORS.darkYellow,
                            }}
                          >
                            Your script contains variables. For now, please choose only one actor to
                            generate multiple videos with variable replacements.
                          </Typography>
                        )}
                        {scriptType === "speech" && actorTab !== "imageActors" && (
                          <Typography
                            variant="body2"
                            style={{
                              marginTop: "4px",
                              fontSize: "12px",
                              color: THEME_COLORS.darkYellow,
                            }}
                          >
                            Speech-to-speech voice conversion requires an ElevenLabs voice
                            selection. Without this, your video will use the original audio exactly
                            as uploaded (no voice conversion).
                          </Typography>
                        )}
                        {isLoadingAvatars ? (
                          <CircularProgress />
                        ) : (
                          <div className={classes.avatarList}>
                            {/* Actors tab: Regular Actors + Photo Avatars */}
                            {actorTab === "actors" && (
                              <>
                                {actors.length === 0 ? (
                                  <Typography variant="body2" sx={{ color: "#888", fontFamily: "Lexend, sans-serif", py: 2 }}>
                                    No actors added yet. Use "+ Add Actors" to select avatars.
                                  </Typography>
                                ) : (
                                  actors.map((actor) => (
                                    <div
                                      key={actor.avatar_id}
                                      className={classes.avatarItem}
                                      style={{ position: "relative" }}
                                    >
                                      <VoicePlayer
                                        actor={actor}
                                        actorId={actor._id}
                                        audioSrc={
                                          actor.elevenLabsAudioUrl
                                            ? actor.elevenLabsAudioUrl
                                            : actor.heygenVoiceAudioUrl
                                            ? actor.heygenVoiceAudioUrl
                                            : actor.preview_video_url
                                        }
                                        isSelected={selectedVideoActors.includes(actor.avatar_id)}
                                        onSelect={handleSelectActors}
                                        onDeselect={handleDeselectActor}
                                        setVideoPage={setVideoPage}
                                        ensureActorsRegistered={ensureActorsRegistered}
                                        scriptType={scriptType}
                                        selectedVideoActors={selectedVideoActors}
                                        actors={actors}
                                        dimension={dimension}
                                        setDimension={setDimension}
                                        setActors={setActors}
                                        handleApplyTemplate={handleApplyTemplate}
                                        onSwitchToEnhancedMode={handleSwitchToEnhancedMode}
                                        customPhotoAvatars={cachedCustomPhotoAvatars || avatarLabActors}
                                      />
                                      <Tooltip title="Remove Actor">
                                        <IconButton
                                          onClick={() => handleDeselectActor(actor.avatar_id)}
                                          sx={{
                                            position: "absolute",
                                            top: 10,
                                            right: 10,
                                            backgroundColor: "#96938a",
                                            color: THEME_COLORS.lightYellow,
                                            width: 14,
                                            height: 14,
                                            zIndex: 10,
                                            "&:hover": { backgroundColor: THEME_COLORS.darkYellow },
                                          }}
                                        >
                                          <CloseIcon sx={{ fontSize: 14 }} />
                                        </IconButton>
                                      </Tooltip>
                                    </div>
                                  ))
                                )}
                              </>
                            )}

                            {/* Avatar Lab tab */}
                            {actorTab === "avatarLab" && (
                              <>
                                {avatarLabActors.length === 0 ? (
                                  <Typography variant="body2" sx={{ color: "#888", fontFamily: "Lexend, sans-serif", py: 2 }}>
                                    No Avatar Lab actors added yet. Use "+ Add Actors" to select from Avatar Lab.
                                  </Typography>
                                ) : (
                                  avatarLabActors.map((avatarLabActor) => (
                                    <div
                                      key={avatarLabActor?._id}
                                      className={classes.avatarItem}
                                      style={{ position: "relative" }}
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "8px",
                                          left: "8px",
                                          zIndex: 5,
                                          padding: "2px 6px",
                                          borderRadius: "8px",
                                          fontSize: "10px",
                                          fontWeight: "bold",
                                          backgroundColor: "#9C27B0",
                                          color: "white",
                                        }}
                                      >
                                        Avatar Lab
                                      </div>
                                      <AvatarLabVoicePlayer
                                        avatar={avatarLabActor}
                                        isSelected={selectedAvatarLabActors.includes(avatarLabActor?._id)}
                                        onSelect={handleSelectAvatarLabActor}
                                        scriptType={scriptType}
                                        selectedAvatars={selectedAvatarLabActors}
                                        setAvatarLabActors={setAvatarLabActors}
                                        onSwitchToPhotoAvatar={handleSwitchToPhotoAvatarMode}
                                        talkingPhotos={talkingPhotos || undefined}
                                      />
                                      <Tooltip title="Remove Avatar Lab Actor">
                                        <IconButton
                                          onClick={() => handleDeselectAvatarLabActor(avatarLabActor?._id)}
                                          sx={{
                                            position: "absolute",
                                            top: 10,
                                            right: 10,
                                            backgroundColor: "#96938a",
                                            color: THEME_COLORS.lightYellow,
                                            width: 14,
                                            height: 14,
                                            zIndex: 10,
                                            "&:hover": { backgroundColor: THEME_COLORS.darkYellow },
                                          }}
                                        >
                                          <CloseIcon sx={{ fontSize: 14 }} />
                                        </IconButton>
                                      </Tooltip>
                                    </div>
                                  ))
                                )}
                              </>
                            )}

                            {/* Image Actors tab */}
                            {actorTab === "imageActors" && (
                              <>
                                {assetActors.length === 0 ? (
                                  <Typography variant="body2" sx={{ color: "#888", fontFamily: "Lexend, sans-serif", py: 2 }}>
                                    No image actors added yet. Use "+ Add Image Actor" to upload an image.
                                  </Typography>
                                ) : (
                                  assetActors.map((assetActor) => (
                                    <div
                                      key={assetActor._id}
                                      className={classes.avatarItem}
                                      style={{ position: "relative" }}
                                    >
                                      <AssetActorCard
                                        assetActor={assetActor}
                                        isSelected={selectedAssetActors.includes(assetActor._id)}
                                        onSelect={handleSelectAssetActor}
                                        onUpdate={handleUpdateAssetActor}
                                        scriptType={scriptType}
                                      />
                                      <Tooltip title="Remove Image Actor">
                                        <IconButton
                                          onClick={() => handleDeselectAssetActor(assetActor._id)}
                                          sx={{
                                            position: "absolute",
                                            top: 10,
                                            right: 10,
                                            backgroundColor: "#96938a",
                                            color: THEME_COLORS.lightYellow,
                                            width: 14,
                                            height: 14,
                                            zIndex: 10,
                                            "&:hover": { backgroundColor: THEME_COLORS.darkYellow },
                                          }}
                                        >
                                          <CloseIcon sx={{ fontSize: 14 }} />
                                        </IconButton>
                                      </Tooltip>
                                    </div>
                                  ))
                                )}
                              </>
                            )}
                          </div>
                        )}

                        <div style={{ marginTop: "20px" }}>
                          <Typography variant="subtitle1" sx={{ mb: 2 }}>
                            Video Dimensions
                          </Typography>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            <TextField
                              label="Width"
                              type="number"
                              value={dimension.width}
                              onChange={(e) => {
                                const width = parseInt(e.target.value, 10);
                                if (!isNaN(width)) {
                                  // Fixed: Added the missing closing parenthesis
                                  setDimension((prev) => ({ ...prev, width }));
                                }
                              }}
                              inputProps={{ min: 128, max: 4096 }}
                              variant="outlined"
                              size="small"
                              disabled={!canUseFeatures(currentWorkspace)}
                              sx={{
                                "& .MuiInputLabel-root": {
                                  color: "black",
                                },
                              }}
                            />
                            <Typography variant="body1">x</Typography>
                            <TextField
                              label="Height"
                              type="number"
                              value={dimension.height}
                              onChange={(e) => {
                                const height = parseInt(e.target.value, 10);
                                if (!isNaN(height)) {
                                  setDimension((prev) => ({ ...prev, height }));
                                }
                              }}
                              inputProps={{ min: 128, max: 4096 }}
                              variant="outlined"
                              size="small"
                              disabled={!canUseFeatures(currentWorkspace)}
                              sx={{
                                "& .MuiInputLabel-root": {
                                  color: "black",
                                },
                              }}
                            />
                          </div>
                          {dimension.width < 128 ||
                          dimension.width > 4096 ||
                          dimension.height < 128 ||
                          dimension.height > 4096 ? (
                            <Typography variant="body2" color="error" style={{ marginTop: "5px" }}>
                              Width and height must be between 128 and 4096.
                            </Typography>
                          ) : null}
                          <div style={{ marginTop: "12px" }}>
                            <FormControl size="small" sx={{ minWidth: 140 }}>
                              <InputLabel id="resolution-label" sx={{ color: "black" }}>
                                Resolution
                              </InputLabel>
                              <Select
                                labelId="resolution-label"
                                value={resolution}
                                label="Resolution"
                                onChange={(e) =>
                                  setResolution(e.target.value as "4k" | "1080p" | "720p")
                                }
                                disabled={!canUseFeatures(currentWorkspace)}
                              >
                                <MenuItem value="720p">720p</MenuItem>
                                <MenuItem value="1080p">1080p</MenuItem>
                                <MenuItem value="4k">4K</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>

                        <Button
                          className={classes.generateVideosButton}
                          onClick={handleGenerateVideos}
                          disabled={
                            generatingVideos ||
                            (actorTab === "actors" && !selectedVideoActors.length) ||
                            (actorTab === "avatarLab" && !selectedAvatarLabActors.length) ||
                            (actorTab === "imageActors" && !selectedAssetActors.length)
                          }
                        >
                          {generatingVideos ? (
                            <CircularProgress size={20} sx={{ color: "#000" }} />
                          ) : (
                            <LightningArrowIcon width={20} height={20} />
                          )}
                          GENERATE VIDEOS
                        </Button>

                        {/* {selectedVideoActors.length > 0 && (
                          <div style={{ marginTop: "10px" }}>
                            <Typography variant="subtitle2" sx={{ mb: 1, opacity: 0.9 }}>
                              Subtitle look & theme
                            </Typography>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "12px",
                                alignItems: "center",
                              }}
                            >
                              <FormControl size="small" sx={{ minWidth: 140 }}>
                                <InputLabel id="caption-style-label">Caption style</InputLabel>
                                <Select
                                  labelId="caption-style-label"
                                  value={captionStyle}
                                  label="Caption style"
                                  onChange={(e) => setCaptionStyle(e.target.value)}
                                >
                                  {(captionPresets.length ? captionPresets : ["default", "classic", "kinetic", "minimal"]).map((p) => (
                                    <MenuItem key={p} value={p}>
                                      {p}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <FormControl size="small" sx={{ minWidth: 220 }}>
                                <InputLabel id="caption-export-label">Export captions</InputLabel>
                                <Select
                                  labelId="caption-export-label"
                                  value={captionExportType}
                                  label="Export captions"
                                  onChange={(e) => setCaptionExportType(e.target.value as "baked_in" | "separate" | "both")}
                                >
                                  <MenuItem value="baked_in">Baked into video only</MenuItem>
                                  <MenuItem value="separate">Separate file only (SRT/VTT)</MenuItem>
                                  <MenuItem value="both">Both (baked-in + separate file)</MenuItem>
                                </Select>
                              </FormControl>
                              {captionExportType === "both" && (
                                <Typography variant="caption" sx={{ display: "block", mt: 0.5, opacity: 0.85 }}>
                                  You'll get video with captions burned in and a separate subtitle file to download.
                                </Typography>
                              )}
                            </div>
                            <Box sx={{ mt: 1 }}>
                              <Button
                                size="small"
                                onClick={() => setShowCaptionThemeCustom((v) => !v)}
                                endIcon={showCaptionThemeCustom ? <ExpandLess /> : <ExpandMore />}
                                sx={{ textTransform: "none", color: "inherit" }}
                              >
                                Customize appearance
                              </Button>
                              <Collapse in={showCaptionThemeCustom}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 2,
                                    alignItems: "center",
                                    mt: 1,
                                    p: 1.5,
                                    borderRadius: 1,
                                    bgcolor: "action.hover",
                                  }}
                                >
                                  <FormControl size="small" sx={{ minWidth: 140 }}>
                                    <InputLabel>Font</InputLabel>
                                    <Select
                                      value={captionTheme?.fontFamily ?? ""}
                                      label="Font"
                                      onChange={(e) =>
                                        setCaptionTheme((t) => ({
                                          ...t,
                                          fontFamily: e.target.value || undefined,
                                        }))
                                      }
                                    >
                                      <MenuItem value="">Default</MenuItem>
                                      {["Arial", "Helvetica", "Inter", "Roboto", "Open Sans", "Montserrat", "Poppins"].map((f) => (
                                        <MenuItem key={f} value={f}>{f}</MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                  <TextField
                                    size="small"
                                    label="Font size"
                                    type="number"
                                    value={captionTheme?.fontSize ?? ""}
                                    onChange={(e) => {
                                      const v = e.target.value ? Number(e.target.value) : undefined;
                                      setCaptionTheme((t) => ({ ...t, fontSize: v }));
                                    }}
                                    inputProps={{ min: 12, max: 72 }}
                                    sx={{ width: 100 }}
                                  />
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                    <Typography variant="caption">Text color</Typography>
                                    <input
                                      type="color"
                                      value={captionTheme?.color ?? "#ffffff"}
                                      onChange={(e) =>
                                        setCaptionTheme((t) => ({ ...t, color: e.target.value }))
                                      }
                                      style={{ width: 32, height: 28, border: "none", cursor: "pointer", borderRadius: 4 }}
                                    />
                                  </Box>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                    <Typography variant="caption">Background</Typography>
                                    <input
                                      type="color"
                                      value={captionTheme?.backgroundColor ?? "#000000"}
                                      onChange={(e) =>
                                        setCaptionTheme((t) => ({ ...t, backgroundColor: e.target.value }))
                                      }
                                      style={{ width: 32, height: 28, border: "none", cursor: "pointer", borderRadius: 4 }}
                                    />
                                  </Box>
                                  <FormControl size="small" sx={{ minWidth: 120 }}>
                                    <InputLabel>Position</InputLabel>
                                    <Select
                                      value={captionTheme?.position ?? ""}
                                      label="Position"
                                      onChange={(e) =>
                                        setCaptionTheme((t) => ({
                                          ...t,
                                          position: e.target.value || undefined,
                                        }))
                                      }
                                    >
                                      <MenuItem value="">Default</MenuItem>
                                      <MenuItem value="top">Top</MenuItem>
                                      <MenuItem value="center">Center</MenuItem>
                                      <MenuItem value="bottom">Bottom</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Box>
                              </Collapse>
                            </Box>
                          </div>
                        )} */}
                        {/* Multiple Scripts Generation Button */}
                        {videoPage?.script && videoPage.script.length > 1 && (
                          <Tooltip title="Generate a separate video for each of your scripts using a single actor">
                            <Button
                              onClick={() => setIsMultipleScriptsModalOpen(true)}
                              disabled={
                                generatingVideos ||
                                (!actors.length && !avatarLabActors.length && !assetActors.length)
                              }
                              sx={{
                                marginTop: "10px",
                                backgroundColor: "#000",
                                color: THEME_COLORS.yellow,
                                fontWeight: "bold",
                                borderRadius: "8px",
                                padding: "10px 20px",
                                "&:hover": {
                                  backgroundColor: "#222",
                                },
                                "&:disabled": {
                                  backgroundColor: "#444",
                                  color: "#888",
                                },
                              }}
                            >
                              <LightningArrowIcon width={20} height={20} color={THEME_COLORS.yellow} />
                              <span style={{ marginLeft: "8px" }}>GENERATE WITH MULTIPLE SCRIPTS</span>
                            </Button>
                          </Tooltip>
                        )}

                        {currentWorkspace &&
                          currentWorkspace.plan &&
                          currentWorkspace?.generatedVideos -
                            (currentWorkspace?.generatedTestVideos || 0) >=
                            currentWorkspace?.plan?.videoLimit && (
                            <Message
                              text="You reached your video generation limit! Contact our team to get more credits."
                              type="warning"
                            />
                          )}
                      </>
                    )}
                  </div>
                ) : (
                  // Show the generated videos list when `showGeneratedVideos` is true
                  <div>
                    <div>
                      {/* Combined generated videos list */}
                      <div className={classes.generatedVideosList}>
                        {/* Regular Generated Videos */}
                        {videoPage?.generatedVideos.map((video: GeneratedVideo) => (
                          <GeneratedVideoItem
                            key={video.heygenId}
                            video={video}
                            type="regular"
                            onRename={handleRenameVideo}
                            onRefresh={(videoId) => updateVideoStatusAndProject(videoId)}
                            onDownload={handleDownloadVideo}
                            onDownloadCaptions={handleDownloadCaptions}
                            onUploadToDrive={handleOpenGoogleDriveModal}
                            onDelete={deleteGeneratedVideo}
                            onPlay={handleOpenVideoDialog}
                            videoBeingRenamed={videoBeingRenamed}
                            videoBeingRefreshed={videoBeingRefreshed}
                            videoBeingDeleted={videoBeingDeleted}
                          />
                        ))}

                        {/* IV Avatar Videos */}
                        {videoPage?.ivAvatarVideos.map((video: IVAvatarVideo) => (
                          <GeneratedVideoItem
                            key={video.heygenId}
                            video={video}
                            type="avatarLab"
                            onRename={handleRenameIVAvatarVideo}
                            onRefresh={handleRefreshIVAvatarVideo}
                            onDownload={handleDownloadVideo}
                            onDownloadCaptions={handleDownloadCaptions}
                            onUploadToDrive={handleOpenGoogleDriveModal}
                            onDelete={handleDeleteIVAvatarVideo}
                            onPlay={handleOpenVideoDialog}
                            videoBeingRenamed={videoBeingRenamed}
                            videoBeingRefreshed={videoBeingRefreshed}
                            videoBeingDeleted={videoBeingDeleted}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Footer Section */}
          {/* OpenAI Modal */}
          {openAIModal && (
            <OpenAIModal
              open={openAIModal}
              onClose={handleCloseAIModal}
              onUse={handleUseOpenAIResponse}
              scriptPart={scriptPart}
              currentPrompt={currentPrompt}
              setCurrentPrompt={setCurrentPrompt}
            />
          )}
          {/* Actors Dialog */}
          {videoPage && (
            <ActorsDialog
              open={isActorsDialogOpen}
              actors={videoPage.actors}
              avatarLabActors={avatarLabActors}
              onClose={() => setIsActorsDialogOpen(false)}
              onSelectActors={handleDoneSelectingAvatars}
              onSelectAvatarLabActors={handleDoneSelectingAvatarLabActors}
              selectedActors={videoPage.actors || []}
              mode="normal"
            />
          )}
          {/* Asset Actor Creation Modal */}
          <AssetActorCreationModal
            open={isAssetActorModalOpen}
            onClose={() => setIsAssetActorModalOpen(false)}
            videoPageId={videoPage?._id || videoPageId || ""}
            onCreated={handleAssetActorCreated}
          />
          {isVideoDialogOpen && !!videoUrl && (
            <VideoDialog
              videoUrl={videoUrl}
              open={isVideoDialogOpen}
              onClose={handleCloseVideoDialog}
              captionUrl={captionUrl}
            />
          )}
          {isEditDialogOpen && (
            <Dialog open={isEditDialogOpen} onClose={handleEditDialogClose}>
              <DialogTitle>Edit Video Page Name</DialogTitle>
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Video Page Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={updatedName}
                  onChange={(e) => setUpdatedName(e.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleEditDialogClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleUpdateVideoPageName} color="primary">
                  Update
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {/* Script Guidelines Modal */}
          <ScriptGuidelinesModal
            open={isGuidelinesModalOpen}
            onClose={() => setIsGuidelinesModalOpen(false)}
            scriptType={scriptType}
          />
          <TemplateDialog
            open={isTemplateModalOpen}
            onClose={() => setIsTemplateModalOpen(false)}
            actors={actors}
            workspaceId={currentWorkspace?._id || ""}
            videoPageId={videoPageId || ""}
            onTemplateAdded={handleTemplateAdded}
            onApplyTemplate={handleApplyTemplate} // Pass the updated handler
          />
          {isVariableModalOpen && (
            <VariableModal
              isOpen={isVariableModalOpen}
              onClose={() => setIsVariableModalOpen(false)}
              currentScript={currentScript}
              onSave={async (updatedScript: Script) => {
                setCurrentScript(updatedScript);
                await handleScriptSave(); // Save to database immediately
              }}
              currentWorkspace={currentWorkspace}
              setCurrentScript={setCurrentScript}
            />
          )}
          {googleDriveModalOpen && (
            <GoogleDriveUploadModal
              open={googleDriveModalOpen}
              onClose={handleCloseGoogleDriveModal}
              video={selectedVideoForUpload}
              userId={user?._id}
              onDriveUploadSuccess={handleDriveUploadSuccess}
            />
          )}
          {isMultipleScriptsModalOpen && (
            <MultipleScriptsModal
              open={isMultipleScriptsModalOpen}
              onClose={() => setIsMultipleScriptsModalOpen(false)}
              scripts={videoPage?.script || []}
              selectedActors={actors}
              selectedAvatarLabActors={avatarLabActors}
              selectedAssetActors={assetActors}
              onGenerate={handleGenerateWithMultipleScripts}
              isGenerating={generatingVideos}
            />
          )}
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
};

const VideoAutoRefresh = ({ video, updateVideoStatusAndProject }: any) => {
  useEffect(() => {
    let intervalId: any;

    if (video.status !== "completed") {
      intervalId = setInterval(() => {
        updateVideoStatusAndProject(video.heygenId);
      }, 15000); // 30 seconds
    }

    // Clean up the interval when the status becomes "completed" or component unmounts
    return () => clearInterval(intervalId);
  }, [video.status, video.heygenId, updateVideoStatusAndProject]);

  return null; // This component does not render anything
};

export default VideoPage;
